<template>
  <div class="start" :style="{ background: info && info.theme_color }">
    <div class="white"></div>
    <div class="box">
      <AppNavbar
        v-if="isApp"
        :placeholder="true"
        :options="options"
        :zIndex="999"
        :title="title"
      >
      </AppNavbar>
      <DownloadApp
        v-else-if="!isApp && $route.query.id != 11"
        :placeholder="true"
      ></DownloadApp>
      <template v-if="info">
        <!-- 整图 -->
        <div class="poster-12" v-if="[12].includes(qid * 1)">
          <img class="image-12" :src="info.que_cover" alt="" />
          <div class="btn-12" @click="bindTest">
            <div>{{ info.que_attr == 1 ? '开始填写' : '开始测试' }}</div>
            <img
              class="point-12"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/7df45cdb97dd326edb8610918f83acfe.png"
              alt=""
            />
            <!-- <WxOpenLaunchApp v-if="showLaunch" class="open-app" :extinfo="extinfo">
                            </WxOpenLaunchApp> -->
          </div>
        </div>
        <div class="poster" v-else>
          <div class="top">
            <img
              class="logo"
              v-if="$route.query.id != 11"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/betterwe_watermark"
              alt=""
            />
            <img
              v-else
              class="jm-logo"
              src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2026-02/dd5a05708a56a6dbb01068eb23dbb984_wh=720_64.webp"
              alt=""
            />
            <div class="text" v-if="$route.query.id != 11"
              >@betterWE减肥研究所</div
            >
          </div>
          <div class="paper">
            <div class="container">
              <template v-if="![11].includes($route.query.id * 1)">
                <div class="c-top">
                  <div class="zh">{{ info.que_type_name }}</div>
                  <div class="en">{{ info.que_en_title }}</div>
                </div>
                <div class="title" v-html="info.que_title"></div>
                <div class="desc">{{ info.que_explain }}</div>
                <img class="image" :src="info.que_cover" alt="" />
              </template>
              <img v-else class="image" :src="info.que_cover" alt="" />
              <div class="time" v-if="info.isStatistics"
                ><span v-if="info.que_answer_num"
                  >共
                  <span class="bold">{{ info.que_answer_num }}</span>
                  道问题，</span
                ><span v-if="info.que_time"
                  >约需
                  <span class="bold">{{ info.que_time }}</span> 分钟完成</span
                ></div
              >
              <div class="btn" @click="bindTest">
                <div>{{ info.que_attr == 1 ? '开始填写' : '开始测试' }}</div>
                <img
                  class="point"
                  src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/7df45cdb97dd326edb8610918f83acfe.png"
                  alt=""
                />
                <!-- <WxOpenLaunchApp v-if="showLaunch" class="open-app" :extinfo="extinfo">
                            </WxOpenLaunchApp> -->
              </div>
            </div>
            <img
              class="paper-btm"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/8dbd77e6116f63ca18836824ea095fd7.png"
              alt=""
            />
          </div>
        </div>
      </template>
      <AppLoading class="loading" v-if="!loaded" />
      <van-overlay :show="showOpen" z-index="99" :lock-scroll="false">
        <img
          class="ad-open"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/pub-share-open"
          alt=""
        />
      </van-overlay>
    </div>
    <MyLogin
      v-if="showLogin"
      class="login-content"
      @login="bindLogin"
      @close="bindClose"
    ></MyLogin>
  </div>
</template>
<script>
import MyLogin from './components/login.vue'
import AppLoading from '@/components/app/loading/loading'
import AppNavbar from '@/components/app/nav-bar/index.vue'
import DownloadApp from './components/download-app.vue'
import WxOpenLaunchApp from '@/components/wx/wx-open-app.vue'
import BetterweWxApi from '@/components/wx/control.js'
export default {
  components: {
    AppLoading,
    AppNavbar,
    DownloadApp,
    WxOpenLaunchApp,
    MyLogin
  },
  data() {
    return {
      qid: this.$route.query.id * 1,
      isApp: false,
      isWx: false,
      options: {},
      title: '',
      loaded: false,
      info: null,
      extinfo: '',
      showOpen: false,
      showLogin: false
    }
  },
  computed: {
    //是否显示微信跳转app组件
    showLaunch() {
      return (
        !this.$route.query.login &&
        !this.isApp &&
        this.isWx &&
        this.info.que_scope != 1
      )
    }
  },
  created() {
    this.extinfo = '/web?url=' + encodeURIComponent(location.href)
    this.isApp = this.$http._isApp()
    this.isWeixn()
    this.getInfo()
    this.bindLog()
  },
  mounted() {},
  methods: {
    setShareData(data) {
      let shareData = {
        link: location.href,
        desc: data.que_explain || '',
        title: data.que_title.replace(/<\s*br\s*\/*\s*>/g, ','),
        imgUrl: data.que_cover || '' // 分享的缩略图的url
      }
      BetterweWxApi.setShareData(shareData, shareData)
    },
    checkUser() {
      this.$toast.loading()
      let params = {
        que_id: this.$route.query.id
      }
      this.$http
        .postBaseApp('que/QueBase/judgeUserIdentity', params)
        .then((res) => {
          res = res.data
          this.$toast.clear()
          if (res.code == 200) {
            this.jumpQution()
          } else if (res.code == 401) {
            this.showLogin = true
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
    },
    bindLog() {
      if (this.$route.query.sfrom == 'question') {
        let params = {}
        if (this.$route.query.id) {
          params.id = this.$route.query.id
        }
        this.$buryPoint('BG_QUESTION_START', params)
      }
      this.$http.addDataLog({
        eventk: 'SHOW_common_questions_start',
        eventv: this.$route.query.id
      })
    },
    // 判断是否微信环境
    isWeixn() {
      let ua = navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        this.isWx = true
      } else {
        this.isWx = false
      }
    },
    bindTest() {
      if (this.info.id == 8) {
        let url =
          '/web?url=' +
          encodeURIComponent('https://www.wjx.cn/vm/mRC01Sk.aspx#')
        this.$betterwe.jumpRoute(url)
        return
      }
      if (this.info.que_scope == 1) {
        //不需要登录时
        let needInApp = !this.$http._isApp() && this.info.que_scope != 1
        if (needInApp) {
          this.$dialog
            .confirm({
              title: '提示',
              message: '是否前往下载App'
            })
            .then(() => {
              this.webJumpApp()
            })
            .catch(() => {})
        } else {
          if (this.$http._isApp()) {
            this.$betterwe.isLogin(() => {
              this.jumpQution()
            })
          } else {
            this.jumpQution()
          }
        }
      } else {
        //需要登录
        this.checkUser()
      }
    },
    jumpQution() {
      this.$router.push({
        path: '/common-questions',
        query: {
          id: this.$route.query.id,
          title: this.info.que_alia,
          sfrom: this.$route.query.sfrom
        }
      })
    },
    getInfo() {
      let params = {
        id: this.$route.query.id
      }
      this.$http.getBaseApp('que/QueBase/initQue', params).then((res) => {
        res = res.data
        if (res.code == 200) {
          this.loaded = true
          res.data.posterColor = 'rgba(209, 164, 233, 1)'
          this.info = res.data
          this.title = res.data.que_alia
          document.title = this.title
          //微信环境并且问卷类型属于减脂营专享则显示引导浏览器打开弹窗
          /* if (this.isWx && this.info.que_scope == 0) {
              this.showOpen = true;
          } */
          //非app、微信环境则默认打开app
          if (!this.isApp && !this.isWx) {
            this.bindJumpApp()
          }
          this.setShareData(res.data)
        } else {
          this.$toast(res.msg)
        }
      })
    },
    bindJumpApp() {
      location.href =
        'betterwe://deepLink/main?newPath=' +
        encodeURIComponent('/web?url=' + encodeURIComponent(location.href))
    },
    //web跳转app
    webJumpApp() {
      this.bindJumpApp()
      setTimeout(() => {
        let url = 'https://member3.gymcity.com.cn/#/app-download'
        if (this.$route.query.sfrom == 'question') {
          url += '?sfrom=question'
        }
        location.href = url
      }, 1000)
    },
    bindLogin() {
      this.checkUser()
      this.showLogin = false
    },
    bindClose() {
      this.showLogin = false
    }
  }
}
</script>
<style lang="scss" scoped>
.loading {
  position: fixed;
  left: 50%;
  top: 30%;
  transform: translate(-50%, -50%);
}

.start {
  position: relative;
  min-height: 100vh;
  background-color: #a99dfb;
}

.white {
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 0;
  background: linear-gradient(
    0deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0.8) 20%,
    rgba(255, 255, 255, 0) 300px,
    rgba(255, 255, 255, 0) 100%
  );
}

.box {
  position: relative;
  z-index: 1;
}

.poster-12 {
  width: 100%;
  box-sizing: border-box;
  .image-12 {
    width: 100%;
    box-sizing: border-box;
  }
  .btn-12 {
    position: relative;
    margin: 0 auto;
    width: 264px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    background: #6759ff;
    box-shadow: 0px 5px 9px 0px rgba(0, 0, 0, 0.09);
    border-radius: 25px;
    font-size: 20px;
    font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #ffffff;
    margin-top: -110px;

    .point-12 {
      position: absolute;
      width: 56px;
      height: 57px;
      right: 27px;
      top: 10px;
      animation: myscale 1.6s linear infinite;
    }
  }
}

.poster {
  padding: 20px;
  box-sizing: border-box;
  overflow: hidden;

  .top {
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .logo {
      width: 60px;
      height: 11px;
    }
    .jm-logo {
      height: 16px;
    }
    .text {
      font-size: 10px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 24px;
    }
  }

  .paper {
    .container {
      padding: 25px 20px;
      background: #ffffff;
      border-radius: 8px 8px 0px 0px;

      .c-top {
        display: flex;
        align-items: center;
        padding-bottom: 7px;
        border-bottom: 1px dashed rgba(82, 68, 133, 0.18);

        .zh {
          border-radius: 4px;
          padding: 0px 7px;
          height: 19px;
          font-size: 11px;
          font-family: Alibaba-PuHuiTi-B, Alibaba-PuHuiTi;
          font-weight: normal;
          color: #ffffff;
          line-height: 19px;
          background: #524485;
          margin-right: 10px;
        }

        .en {
          font-size: 10px;
          font-family: DIN-RegularItalic, DIN;
          font-weight: normal;
          font-style: italic;
          color: rgba(82, 68, 133, 0.6);
          line-height: 28px;
        }
      }

      .title {
        font-size: 30px;
        font-family: AlibabaPuHuiTiM;
        color: #524485;
        line-height: 40px;
        margin-bottom: 7px;
      }

      .desc {
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #524485;
        line-height: 24px;
        margin-bottom: 9px;
      }

      .image {
        width: 100%;
        height: auto;
        min-height: 260px;
        margin-bottom: 16px;
      }

      .time {
        text-align: center;
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #524485;
        line-height: 24px;
        margin-bottom: 10px;

        .bold {
          font-size: 13px;
        }
      }

      .btn {
        position: relative;
        margin: 0 auto;
        width: 264px;
        height: 50px;
        text-align: center;
        line-height: 50px;
        background: #27243c;
        box-shadow: 0px 5px 9px 0px rgba(0, 0, 0, 0.09);
        border-radius: 25px;
        font-size: 20px;
        font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #ffffff;

        .point {
          position: absolute;
          width: 56px;
          height: 57px;
          right: 27px;
          top: 10px;
          animation: myscale 1.6s linear infinite;
        }
      }
    }

    .paper-btm {
      width: 100%;
    }
  }
}

.ad-open {
  width: 100vw;
  position: absolute;
  top: 0;
  right: 1vw;
}

.login-content {
  width: 100%;
  position: absolute;
  left: 0%;
  bottom: 0;
}

@keyframes myscale {
  0% {
    transform: scale(1) translateX(0px);
  }

  50% {
    transform: scale(0.8) translateY(8px);
  }

  100% {
    transform: scale(1) translateX(0px);
  }
}
</style>
